import updateFolderViewStateService from '../services/updateFolderViewStateService';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action } from 'satcheljs/lib/legacy';
import getFolderViewStateFromId from '../selectors/getFolderViewStateFromId';
export function getFolderViewStates() {
    var folderViewStates = getUserConfiguration().ViewStateConfiguration.FolderViewState || [];
    var parsedFolderViewStates = {};
    for (var i = 0, len = folderViewStates.length; i < len; i++) {
        var folderViewState = JSON.parse(folderViewStates[i]);
        parsedFolderViewStates[folderViewState.FolderId.Id] = folderViewState;
    }
    return parsedFolderViewStates;
}
export var updateFolderViewState = action('updateFolderViewState')(function updateFolderViewState(folderId) {
    var folderViewStates = getUserConfiguration().ViewStateConfiguration.FolderViewState || [];
    var isDirty = false;
    // VSO 2194: Folder: folderViewStatesActions only sets the collapsed/expanded FolderViewState if it finds one.
    // We should fix it to properly set it, even if it does not exists.
    for (var i = 0, len = folderViewStates.length; i < len; i++) {
        var userConfigFolderViewState = JSON.parse(folderViewStates[i]);
        var mailFolderViewState = getFolderViewStateFromId(folderId);
        if (userConfigFolderViewState.FolderId.Id === folderId) {
            // update whatever field we care about.
            isDirty = userConfigFolderViewState.IsExpanded != mailFolderViewState.isExpanded;
            userConfigFolderViewState.IsExpanded = mailFolderViewState.isExpanded;
            // serialize it back.
            folderViewStates[i] = JSON.stringify(userConfigFolderViewState);
            break;
        }
    }
    if (isDirty) {
        updateFolderViewStateService(getUserConfiguration());
    }
});
//# sourceMappingURL=folderViewStatesActions.js.map